import { FC, useState } from "react";
import RenderIfVisible from "react-render-if-visible";

import { usePageScrollPositionMemory } from "@ryde/redux";
import {
  ESTIMATED_KANBAN_ITEM_HEIGHT,
  IRideTableDto,
  ScrollAreaEnum,
} from "@ryde/shared";

import { KanbanColumnStyled } from "../rides.kanban.styled";
import { RidesKanbanItemWrapper } from "./rides.kanban.item.wrapper";

interface IKanbanColumnProps {
  gridArea: string;
  items: IRideTableDto[] | null | undefined;
  scrollArea: ScrollAreaEnum;
}

export const KanbanColumn: FC<IKanbanColumnProps> = ({
  items,
  gridArea,
  scrollArea,
}) => {
  const [scrollElement, setScrollElement] = useState<HTMLDivElement | null>(
    null,
  );

  usePageScrollPositionMemory({ element: scrollElement, area: scrollArea });

  return (
    <KanbanColumnStyled
      ref={setScrollElement}
      $gridArea={gridArea}
      className="thin_scrollbar"
    >
      {items?.map((dto, i) => (
        <RenderIfVisible
          key={dto?.id || i}
          stayRendered={true}
          defaultHeight={ESTIMATED_KANBAN_ITEM_HEIGHT}
        >
          <RidesKanbanItemWrapper rideDto={dto} />
        </RenderIfVisible>
      ))}
    </KanbanColumnStyled>
  );
};
